<template>
  <div
    :class="$style.component"
  >
    <p class="viewSubtitle">
      {{t('listTabSmallText').replace('%numCards%', cards.length)}}
    </p>
    <div class="viewTitle">
      <img v-if="currentLanguage === 'fi'" src="../../assets/images/deck-fi.svg" />
      <img v-if="currentLanguage === 'sv'" src="../../assets/images/deck-sv.svg" />
      <img v-if="currentLanguage === 'en'" src="../../assets/images/deck-en.svg" />
    </div>
    <transition-group name="cards" :class="$style.list" tag="div">
      <Card
        v-for="(card, index) in showCards ? cards : []"
        :key="card.id"
        :title="card.title"
        :description="card.description"
        :style="{
          'transition-delay': `${Math.log(index*0.2+1)}s` // I got some tips from our analytics guru Kent, might need some finetuning but this is the best i got
        }"
      />
    </transition-group>
  </div>
</template>

<script>
import {inject, ref} from '@vue/composition-api'
import useTranslations from '@/composition/useTranslations'

export default {
  props: {
    cards: Array,
  },
  setup () {
    const showCards = ref(false)
    setTimeout(() => {
      showCards.value = true
    })

    return {
      showCards,
      currentLanguage: inject('currentLanguage').value,
      t: useTranslations(),
    }
  },
}
</script>

<style scoped lang="scss">
.cards-enter-active {
  transition: all 0.5s cubic-bezier(0.33, 1, 0.68, 1);
}
.cards-enter {
  opacity: 0;
  transform:
    translateX(-150px)
    translateY(50px)
    rotate(-30deg) !important;
}
</style>

<style module lang="scss">
.component {
  display: flex;
  flex-direction: column;
}

.list {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: variables.$spacing-16;
  margin-inline: auto;
  width: 100%;
  max-width: 1140px;
  padding: variables.$spacing-20;

  > * {
    width: calc(50% - 8px - 2px); // remove gap and border-width to avoid wrapping

    @media screen and (max-width: variables.$breakpoint-700) {
      width: 100%;
    }

    @include mixins.cardTilt;
  }
}
</style>
